import React from "react";
import TableComponentWithDialog from "../../../../../page/TableComponentWithDialog";
import { labels } from "../../../../../../../localization/labels";
import InvolvementRoleTypes from "./InvolvementRoleTypes";
import InvolvementRoleTypeService from "../../../../../../../services/InvolvementRoleTypeService";
import CommonUtil from "../../../../../../../utils/CommonUtil";
import TableUtils from "../../../../../../core/Table/TableUtils";

class InvolvementRolesContainer extends TableComponentWithDialog {
  constructor(props) {
    super(props);
    this.involvementRoleTypeService = new InvolvementRoleTypeService();

    this.state = {
      ...this.state,
      involvementRoleTypes: []
    };
  }

  initialSortInfo() {
    return {
      orderBy: "name",
      direction: "asc"
    };
  }

  inheritedDataPropNames = [
    "entityInvolvementRoleTypes",
    "parentInvolvementRoleTypes"
  ];

  loadInvolvementRoleTypes = () => {
    const involvementRoleTypesToRemove = CommonUtil.concatArrays(
      this.getInheritedArraySafely(this.inheritedDataPropNames[0]),
      this.getInheritedArraySafely(this.inheritedDataPropNames[1])
    );

    const pageInfo = this.addPredefinedIdsFilter(
      {},
      involvementRoleTypesToRemove,
      "NOTIN"
    );

    this.prepareCall(
      this.involvementRoleTypeService.getInvolvementRoleTypesBasic(
        pageInfo,
        this.sortInfo,
        this.onInvolvementRoleTypesLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onInvolvementRoleTypesLoad = data => {
    if (data && data._embedded) {
      this.setState({ involvementRoleTypes: data._embedded.content });
    } else {
      this.setState({ involvementRoleTypes: [] });
    }
  };

  loadData = pageInfo => {
    const entityInvolvementRoleTypes = this.getInheritedArraySafely(
      this.inheritedDataPropNames[0]
    );

    pageInfo = this.addPredefinedIdsFilter(
      pageInfo,
      entityInvolvementRoleTypes
    );

    this.prepareCall(
      this.involvementRoleTypeService.getInvolvementRoleTypesBasic(
        pageInfo,
        this.sortInfo,
        this.onDataLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();

    this.loadInvolvementRoleTypes();
  };

  columns = this.initColumns([
    {
      dataField: "id",
      text: labels.id,
      sort: true,
      classes: "column-id",
      headerClasses: "column-header-id"
    },
    {
      dataField: "name",
      text: labels.name,
      headerClasses: "column-header",
      sort: true,
      formatter: TableUtils.textFormatter
    },
    {
      dataField: "description",
      text: labels.description,
      headerClasses: "column-header",
      formatter: TableUtils.textFormatter
    }
  ]);

  possibleSizesPerPage() {
    return [5, 10, 15];
  }

  handleShowReset = () => {
    this.handleShow();
  };

  resetEntity = () => {
    return {
      description: undefined
    };
  };

  handleDialogChange = event => {
    let { newEntity } = this.state;
    const path = event.target.id;
    if (path) {
      CommonUtil.setDeepOnStringPath(newEntity, path, event.target.value);
    } else {
      newEntity = event.target.value;
    }
    const disabled = newEntity ? false : true;
    this.setState({ newEntity, disabled });
  };

  selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    selectColumnStyle: {
      textAlign: "center"
    },
    headerColumnStyle: {
      textAlign: "center"
    }
  };

  render() {
    return (
      <>
        <InvolvementRoleTypes
          {...this.renderProps()}
          selectRow={this.props.hideActionButtons ? undefined : this.selectRow}
          handleShow={
            this.props.hideActionButtons ? undefined : this.handleShow
          }
          handleOnDelete={
            this.props.hideActionButtons ? undefined : this.handleOnDelete
          }
          disabled={this.state.disabled}
          involvementRoleTypes={this.state.involvementRoleTypes}
        />
      </>
    );
  }
}

export default InvolvementRolesContainer;
